<template>
    <div>
        <el-popover
            placement="bottom-start"
            width="200"
            trigger="click"
        >
            <input class="inputstyle" v-model="search" @input="checkSearch()"/>
            <div class="oplist">
                <div @click="allSelect()">全选</div>
                <div @click="clearSelect()">清空</div>
                <div @click="invertSelect()">反选</div>
            </div>
            <div class="opitem" v-for="(item,index) in dataList" :key="index">
                <input class="selstyle" type="checkbox" :checked='item.select' @change="changeSelect(item)"/>
                <div class="uni_ellipsis" style="padding-left:5px;width:170px">{{item.label}}</div>
            </div>
            <el-button style="width:160px;text-align:left" slot="reference" :loading="load" @click="init()">
                {{selectList.length>0?'已选择'+selectList.length+'条':'请选择'}}
                <i class="el-icon-setting" style="float:right;font-size:14px" @click.stop.prevent="showList()"></i>
            </el-button>
        </el-popover>
        <el-dialog :visible.sync="selectListDialog" title="选择列表" append-to-body>
            <div class="slectListPanel" v-if="selectList.length>0">
                <div class="opitem" v-for="(item,index) in selectList" :key="index">
                    <i class="el-icon-delete" style="height:30px;font-size:14px;line-height:30px;cursor: pointer;" @click="delOne(item)"></i>
                    <div class="uni_ellipsis" style="padding-left:5px;width:170px">{{item.label}}</div>
                </div>
            </div>
            <div class="slectListPanel" v-else>
                <div class="empty_font">还未选择</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props:{
        searchLabel:{
            type:String,
            default:'product',
        },
        showLabel:{
            type:String,
            default:'name',
        },
        url:{
            type:String,
            default:'/mobile/product/getList'
        }
    },
    data(){
        return{
            search:'',
            selectList:[],
            dataList:[],
            load:false,
            tempSearch:'',
            selectListDialog:false,
            t:null,
        };
    },
    methods:{
        init:function(){
            if(this.dataList.length==0){
                this.searchInfo();
            }
        },
        checkSearch:function(){
            if(this.search==this.tempSearch){
                return;
            }
            if(this.load){
                if(this.tempSearch!=this.search){
                    this.search = this.tempSearch;
                    return;
                }
            }
            this.tempSearch = this.search;
            if(this.t){
                clearTimeout(this.t);
                this.t = null;
            }
            this.t = setTimeout(()=>{
                this.searchInfo();
            },500);
            
        },
        searchInfo:function(){
            this.load = true;
            var obj = {
                page:1,
                limit:10,
            }
            obj[this.searchLabel] = this.search;
            this.dataList = [];
            if(this.url=='/mobile/customer/listCustomer'){
                obj.state = this.$global.customerState?this.$global.customerState:'';
            }
            this.$api.getInfoPostSingle(this.url,obj).then(res=>{
                if(res.data.code==1&&res.data.count>0){
                    res.data.data.forEach(e => {
                        var unSelect = true;
                        for(let i in this.selectList){
                            if(this.selectList[i].id==e.id){
                                unSelect = false;
                                this.dataList.push(this.selectList[i]);
                                break;
                            }
                        }
                        if(unSelect){
                            let ob1 = {
                                id:e.id,
                                label:e[this.showLabel],
                                select:false,
                            }
                            this.dataList.push(ob1);
                        }
                    });
                }
                this.load = false;
            })
        },
        changeSelect:function(item){
            if(item.select){
                this.cancelOne(item);
            }else{
                this.selectOne(item);
            }
            this.updateSelect();
        },
        selectOne:function(item){
            item.select = true;
            this.selectList.push(item);
        },
        delOne:function(item){
            this.cancelOne(item);
            this.updateSelect();
        },
        cancelOne:function(item){
            let index = -1;
            for(let i in this.selectList){
                if(this.selectList[i].id==item.id){
                    index = i;
                    break;
                }
            }
            if(index>=0){
                this.selectList.splice(index,1);
            }
            item.select = false;
        },
        allSelect:function(){
            this.dataList.forEach(e=>{
                if(!e.select){
                    this.selectOne(e);
                }
            })
             this.updateSelect();
        },
        clearSelect:function(){
            this.selectList.forEach(e=>{
                e.select = false;
            })
            this.selectList = [];
            this.updateSelect();
        },
        reset:function(){
            this.search = "";
            this.selectList = [];
            this.dataList = [];
            this.tempSearch = "";
            this.load = false;
        },
        invertSelect:function(){
            this.dataList.forEach(e=>{
                if(e.select){
                    this.cancelOne(e);
                }else{
                    this.selectOne(e);
                }
            })
            this.updateSelect();
        },
        updateSelect:function(){
            let arr = [];
            this.selectList.forEach(e=>{
                arr.push(e.id);
            })
            this.$emit('changeSelect',arr.join(','));
        },
        showList:function(){
            this.selectListDialog = true;
        }
    }
}
</script>
<style scoped lang="scss">
.oplist{
    display: flex;
    justify-content: center;
    div{
        line-height: 40px;
        font-size: 14px;
        padding: 0 10px;
        cursor: pointer;
        color: #999;
    }
}
.inputstyle{
    width: 200px;
    height: 40px;
    text-indent: 10px;
    box-sizing: border-box;
    border: 1px solid #e6e6e6;
}
.inputstyle:focus{
    outline: none;
    border: 1px solid #409eff;
}
.selstyle{
    width: 20px;
    height: 20px;
    outline: none;
}
.slectListPanel{
    display: flex;
    flex-wrap: wrap;
    max-height: 560px;
}
.empty_font{
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #999;
}
.opitem{
    line-height:30px;
    height:30px;
    width:200px;
    display: flex;
}
</style>